import {ResendEmailLoader} from './ResendEmailLoader';
import Eye from './Eye';
import AttentionOutline from './AttentionOutline';
import EyeInvisible from './EyeInvisible';
import DatabaseCalendar from './DatabaseCalendar';
import ArrowDatepickerPrev from './ArrowDatepickerPrev';
import ArrowDatepickerNext from './ArrowDatepickerNext';
import PlayVideoBtn from './PlayVideoBtn';
import DatabaseSearch from './DatabaseSearch';
import DatabaseCurrency from './DatabaseCurrency';
import ArrowLink from './ArrowLink';
import Close from './Close';
import NotificationSuccess from './NotificationSuccess';
import NotificationClose from './NotificationClose';
import PlayVideoBtnSmall from './PlayVideoBtnSmall';
import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';
import ArrowSliderPrev from './ArrowSliderPrev';
import ArrowSliderNext from './ArrowSliderNext';
import Help from './Help';
import Warning from './Warning';
import CheckMark from './CheckMark';
import CloseModal from './CloseModal';
import Cart from './Cart';
import ArrowSelectDown from './ArrowSelectDown';
import Notifications from './notifications';
import PaperPlane from './paper-plane';
import User from './user';
import UserDefault from './user-default';
import Mail from './mail';
import Sun from './sun';
import Moon from './moon';
import Logout from './logout';
import EmptyWarning from './empty-warning';
import Menu from './menu';
import SelectDropdownCheckMark from './SelectDropdownCheckMark';
import SelectDropdownCheckMarkV2 from './SelectDropdownCheckMark_v2';
import Home from './home';
import Portfolio from './portfolio';
import Settings from './settings';
import Calendar from './kalendar';
import Folder from './folder';
import Boosters from './boosters';
import ChevronLeft from './chevron-left';
import ExternalLink from './ExternalLink';
import ScoreCounter from './ScoreCounter';
import Ellipse from './Ellipse';
import ArrowDownward from './ArrowDownward';
import ViewPort from './ViewPort';
import ViewPortTable from './ViewPortTable';
import SearchIcon from './SearchIcon';
import Union from './Union';
import Pocket from './Pocket';
import Edit from './Edit';
import HelpShadow from './HelpShadow';
import GlobeOutline from './GlobeOutline';
import SettingIcon from './SettingIcon';
import NotificationWarning from './NotificationWarning';
import AppleIcon from './AppleIcon';
import FbIcon from './FbIcon';
import GoogleIcon from './GoogleIcon';
import PlusIcon from './PlusIcon';
import Favorite from './Favorite';
import Plus from './Plus';
import CartUpcoming from './CartUpcoming';
import Faq from './Faq';
import ThreeDots from './ThreeDots';
import Trash from './Trash';
import NotificationError from './NotificationError';
import CardChip from './CardChip';
import PaymentCardIcon from './PaymentCardIcon';
import SyncArrows from './SyncArrows';
import Download from './Download';
import EditPensil from './EditPensil';
import DeleteBasket from './DeleteBasket';
import SpeedometerArrow from './SpeedometerArrow';
import Price from './Price';
import ArrowUp from './ArrowUp';
import Database from './Database';
import DollarIcon from './DollarIcon';
import Competitor from './competitor';
import Bd from './BD';

// MOBILE MENU
import DashboardMobile from './mobile-menu/dashboardMobile';
import CollectionMobile from './mobile-menu/collectionMobile';
import BdMobile from './mobile-menu/bdMobile';
import PortfolioMobile from './mobile-menu/portfolioMobile';

import NotificationDelete from './NotificationDelete';
import SettingsMobile from './mobile-menu/settingsMobile';
import DatabaseMobile from './mobile-menu/databaseMobile';

import Visa from './Visa';
import AmericanExpress from './AmericanExpress';
import Belfius from './Belfius';
import Maestro from './Maestro';
import MasterCard from './Mastercard';
import Paypal from './Paypal';
import Lock from './Lock';
import MoreSchedule from './MoreSchedule';

export const svg = {
  ResendEmailLoader,
  Eye,
  AttentionOutline,
  EyeInvisible ,
  DatabaseCalendar ,
  ArrowDatepickerPrev ,
  ArrowDatepickerNext ,
  PlayVideoBtn ,
  DatabaseSearch ,
  DatabaseCurrency ,
  ArrowLink ,
  Close ,
  NotificationSuccess ,
  NotificationClose ,
  PlayVideoBtnSmall ,
  ArrowLeft ,
  ArrowRight ,
  ArrowSliderPrev ,
  ArrowSliderNext ,
  Help ,
  Warning ,
  CheckMark ,
  CloseModal ,
  Cart ,
  ArrowSelectDown ,
  Notifications ,
  PaperPlane ,
  User ,
  UserDefault,
  Mail ,
  Sun ,
  Moon ,
  Logout ,
  EmptyWarning ,
  Menu ,
  SelectDropdownCheckMark ,
  SelectDropdownCheckMarkV2 ,
  Home ,
  Portfolio ,
  Settings ,
  Calendar ,
  Folder ,
  Boosters ,
  ChevronLeft,
  ExternalLink ,
  ScoreCounter ,
  Ellipse ,
  ArrowDownward,
  ViewPort ,
  ViewPortTable ,
  SearchIcon ,
  Union ,
  Pocket,
  Edit ,
  HelpShadow ,
  GlobeOutline,
  SettingIcon ,
  NotificationWarning ,
  AppleIcon ,
  FbIcon ,
  GoogleIcon ,
  PlusIcon ,
  Favorite ,
  Plus ,
  CartUpcoming,
  Faq ,
  ThreeDots ,
  Trash ,
  NotificationError ,
  CardChip ,
  PaymentCardIcon ,
  SyncArrows ,
  Download ,
  EditPensil ,
  DeleteBasket,
  SpeedometerArrow ,
  Price ,
  ArrowUp ,
  Database ,
  DollarIcon ,
  Competitor,
  Bd,

  DashboardMobile,
  PortfolioMobile,
  CollectionMobile,

  NotificationDelete,
  SettingsMobile,
  DatabaseMobile,
  BdMobile,

  Visa ,
  AmericanExpress ,
  Belfius ,
  Maestro ,
  MasterCard ,
  Paypal ,
  Lock ,
  MoreSchedule ,
}
